























import { Component, Vue } from 'vue-property-decorator'
import { UserInfo } from '@/interfaces/vuexStateInterface'
import { setMessageOpen, setHomeWorkOpen, setLetterOpen, setCovOpen } from '@/apis/myInfo/myInfo.ts'
import i18n from '@/lang';
@Component({})
export default class MyMessageSet extends Vue {
  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo
  }
  private checked: boolean = true
  private settingData: Array<any> = [
    {
      title: i18n.t('ktpMy.课堂成员变动') as string,
      titleDetail: i18n.t('ktpMy.默认周六21:30接收成员变动消息推送') as string,
      isOn: this.userInfo.notify1,
    },
    {
      title: i18n.t('ktpMy.作业到期') as string,
      titleDetail: i18n.t('ktpMy.作业到截止日期接收消息通知') as string,
      isOn: this.userInfo.notify2,
    },
    {
      title: i18n.t('ktpMy.课堂私信') as string,
      titleDetail:  i18n.t('ktpMy.有老师同学私信后接收消息推送') as string,
      isOn: this.userInfo.notify3,
    },
    {
      title: i18n.t('ktpMy.话题提醒') as string,
      titleDetail: i18n.t('ktpMy.有老师同学发起话题后接收消息推送') as string,
      isOn: this.userInfo.notify4,
    },
  ]
  isShow(item: {title: string, titleDetail:string, isOn: number}):boolean {
    if (item.title === i18n.t('ktpMy.课堂成员变动')) {
      if (this.userInfo.usertype === '0') {
        return false;
      }
    }
    return true;
  }
  // 控制开关
  onInput(index: any) {
    if (this.settingData[index].isOn === '0') {
      this.settingData[index].isOn = '1'
    } else {
      this.settingData[index].isOn = '0'
    }
    let flag
    if (this.settingData[index].isOn) {
      flag = '1'
    } else {
      flag = '0'
    }
    switch (index) {
      case 0:
        setMessageOpen({ flage: flag })
          .then((res) => {
            this.$store.dispatch('setUserInfo')
          })
          .catch((e) => {})
        break
      case 1:
        setHomeWorkOpen({ flage: flag })
          .then((res) => {
            this.$store.dispatch('setUserInfo')
          })
          .catch((e) => {})
        break
      case 2:
        setLetterOpen({ flage: flag })
          .then((res) => {
            this.$store.dispatch('setUserInfo')
          })
          .catch((e) => {})
        break
      case 3:
        setCovOpen({ flage: flag })
          .then((res) => {
            this.$store.dispatch('setUserInfo')
          })
          .catch((e) => {})
        break
    }
  }

  created() {
    this.$setNavInfo({
      type: 'normal',
      title: i18n.t('ktpMy.消息设置') as string,
      showTitle: true,
    })
  }
  //消息管理设置
  getMessageSet() {}
}
